"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[83474],{

/***/ 90567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_alert; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloseOutlined.js + 1 modules
var CloseOutlined = __webpack_require__(97937);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CheckCircleOutlined.js + 1 modules
var CheckCircleOutlined = __webpack_require__(8751);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/ExclamationCircleOutlined.js + 1 modules
var ExclamationCircleOutlined = __webpack_require__(11475);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/InfoCircleOutlined.js + 1 modules
var InfoCircleOutlined = __webpack_require__(45605);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloseCircleOutlined.js + 1 modules
var CloseCircleOutlined = __webpack_require__(18429);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CheckCircleFilled.js + 1 modules
var CheckCircleFilled = __webpack_require__(89739);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/ExclamationCircleFilled.js + 1 modules
var ExclamationCircleFilled = __webpack_require__(21640);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/InfoCircleFilled.js + 1 modules
var InfoCircleFilled = __webpack_require__(78860);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloseCircleFilled.js + 1 modules
var CloseCircleFilled = __webpack_require__(4340);
// EXTERNAL MODULE: ./node_modules/rc-motion/es/index.js + 17 modules
var es = __webpack_require__(88320);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js + 1 modules
var context = __webpack_require__(59844);
;// CONCATENATED MODULE: ./node_modules/antd/es/_util/getDataOrAriaProps.js
function getDataOrAriaProps(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') && key.substr(0, 7) !== 'data-__') {
      prev[key] = props[key];
    }

    return prev;
  }, {});
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(32531);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js + 1 modules
var createSuper = __webpack_require__(51630);
;// CONCATENATED MODULE: ./node_modules/antd/es/alert/ErrorBoundary.js







var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(ErrorBoundary, _React$Component);

  var _super = (0,createSuper/* default */.Z)(ErrorBoundary);

  function ErrorBoundary() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ErrorBoundary);

    _this = _super.apply(this, arguments);
    _this.state = {
      error: undefined,
      info: {
        componentStack: ''
      }
    };
    return _this;
  }

  (0,createClass/* default */.Z)(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.setState({
        error: error,
        info: info
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          message = _this$props.message,
          description = _this$props.description,
          children = _this$props.children;
      var _this$state = this.state,
          error = _this$state.error,
          info = _this$state.info;
      var componentStack = info && info.componentStack ? info.componentStack : null;
      var errorMessage = typeof message === 'undefined' ? (error || '').toString() : message;
      var errorDescription = typeof description === 'undefined' ? componentStack : description;

      if (error) {
        return /*#__PURE__*/react.createElement(es_alert, {
          type: "error",
          message: errorMessage,
          description: /*#__PURE__*/react.createElement("pre", null, errorDescription)
        });
      }

      return children;
    }
  }]);

  return ErrorBoundary;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/antd/es/_util/reactNode.js
var reactNode = __webpack_require__(96159);
;// CONCATENATED MODULE: ./node_modules/antd/es/alert/index.js




var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

















var iconMapFilled = {
  success: CheckCircleFilled/* default */.Z,
  info: InfoCircleFilled/* default */.Z,
  error: CloseCircleFilled/* default */.Z,
  warning: ExclamationCircleFilled/* default */.Z
};
var iconMapOutlined = {
  success: CheckCircleOutlined/* default */.Z,
  info: InfoCircleOutlined/* default */.Z,
  error: CloseCircleOutlined/* default */.Z,
  warning: ExclamationCircleOutlined/* default */.Z
};

var Alert = function Alert(_a) {
  var _classNames2;

  var description = _a.description,
      customizePrefixCls = _a.prefixCls,
      message = _a.message,
      banner = _a.banner,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      style = _a.style,
      onMouseEnter = _a.onMouseEnter,
      onMouseLeave = _a.onMouseLeave,
      onClick = _a.onClick,
      afterClose = _a.afterClose,
      showIcon = _a.showIcon,
      closable = _a.closable,
      closeText = _a.closeText,
      action = _a.action,
      props = __rest(_a, ["description", "prefixCls", "message", "banner", "className", "style", "onMouseEnter", "onMouseLeave", "onClick", "afterClose", "showIcon", "closable", "closeText", "action"]);

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      closed = _React$useState2[0],
      setClosed = _React$useState2[1];

  var ref = react.useRef();

  var _React$useContext = react.useContext(context/* ConfigContext */.E_),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var prefixCls = getPrefixCls('alert', customizePrefixCls);

  var handleClose = function handleClose(e) {
    var _a;

    setClosed(true);
    (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props, e);
  };

  var getType = function getType() {
    var type = props.type;

    if (type !== undefined) {
      return type;
    } // banner 模式默认为警告


    return banner ? 'warning' : 'info';
  }; // closeable when closeText is assigned


  var isClosable = closeText ? true : closable;
  var type = getType();

  var renderIconNode = function renderIconNode() {
    var icon = props.icon; // use outline icon in alert with description

    var iconType = (description ? iconMapOutlined : iconMapFilled)[type] || null;

    if (icon) {
      return (0,reactNode/* replaceElement */.wm)(icon, /*#__PURE__*/react.createElement("span", {
        className: "".concat(prefixCls, "-icon")
      }, icon), function () {
        return {
          className: classnames_default()("".concat(prefixCls, "-icon"), (0,defineProperty/* default */.Z)({}, icon.props.className, icon.props.className))
        };
      });
    }

    return /*#__PURE__*/react.createElement(iconType, {
      className: "".concat(prefixCls, "-icon")
    });
  };

  var renderCloseIcon = function renderCloseIcon() {
    return isClosable ? /*#__PURE__*/react.createElement("button", {
      type: "button",
      onClick: handleClose,
      className: "".concat(prefixCls, "-close-icon"),
      tabIndex: 0
    }, closeText ? /*#__PURE__*/react.createElement("span", {
      className: "".concat(prefixCls, "-close-text")
    }, closeText) : /*#__PURE__*/react.createElement(CloseOutlined/* default */.Z, null)) : null;
  }; // banner 模式默认有 Icon


  var isShowIcon = banner && showIcon === undefined ? true : showIcon;
  var alertCls = classnames_default()(prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames2 = {}, (0,defineProperty/* default */.Z)(_classNames2, "".concat(prefixCls, "-with-description"), !!description), (0,defineProperty/* default */.Z)(_classNames2, "".concat(prefixCls, "-no-icon"), !isShowIcon), (0,defineProperty/* default */.Z)(_classNames2, "".concat(prefixCls, "-banner"), !!banner), (0,defineProperty/* default */.Z)(_classNames2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames2), className);
  var dataOrAriaProps = getDataOrAriaProps(props);
  return /*#__PURE__*/react.createElement(es/* default */.Z, {
    visible: !closed,
    motionName: "".concat(prefixCls, "-motion"),
    motionAppear: false,
    motionEnter: false,
    onLeaveStart: function onLeaveStart(node) {
      return {
        maxHeight: node.offsetHeight
      };
    },
    onLeaveEnd: afterClose
  }, function (_ref) {
    var motionClassName = _ref.className,
        motionStyle = _ref.style;
    return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
      ref: ref,
      "data-show": !closed,
      className: classnames_default()(alertCls, motionClassName),
      style: (0,esm_extends/* default */.Z)((0,esm_extends/* default */.Z)({}, style), motionStyle),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onClick: onClick,
      role: "alert"
    }, dataOrAriaProps), isShowIcon ? renderIconNode() : null, /*#__PURE__*/react.createElement("div", {
      className: "".concat(prefixCls, "-content")
    }, /*#__PURE__*/react.createElement("div", {
      className: "".concat(prefixCls, "-message")
    }, message), /*#__PURE__*/react.createElement("div", {
      className: "".concat(prefixCls, "-description")
    }, description)), action ? /*#__PURE__*/react.createElement("div", {
      className: "".concat(prefixCls, "-action")
    }, action) : null, renderCloseIcon());
  });
};

Alert.ErrorBoundary = ErrorBoundary;
/* harmony default export */ var es_alert = (Alert);

/***/ }),

/***/ 94594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_switch; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMergedState.js
var useMergedState = __webpack_require__(21770);
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(15105);
;// CONCATENATED MODULE: ./node_modules/rc-switch/es/index.js







var Switch = react.forwardRef(function (_ref, ref) {
  var _classNames;

  var _ref$prefixCls = _ref.prefixCls,
      prefixCls = _ref$prefixCls === void 0 ? 'rc-switch' : _ref$prefixCls,
      className = _ref.className,
      checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      loadingIcon = _ref.loadingIcon,
      checkedChildren = _ref.checkedChildren,
      unCheckedChildren = _ref.unCheckedChildren,
      onClick = _ref.onClick,
      onChange = _ref.onChange,
      onKeyDown = _ref.onKeyDown,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref, ["prefixCls", "className", "checked", "defaultChecked", "disabled", "loadingIcon", "checkedChildren", "unCheckedChildren", "onClick", "onChange", "onKeyDown"]);

  var _useMergedState = (0,useMergedState/* default */.Z)(false, {
    value: checked,
    defaultValue: defaultChecked
  }),
      _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
      innerChecked = _useMergedState2[0],
      setInnerChecked = _useMergedState2[1];

  function triggerChange(newChecked, event) {
    var mergedChecked = innerChecked;

    if (!disabled) {
      mergedChecked = newChecked;
      setInnerChecked(mergedChecked);
      onChange === null || onChange === void 0 ? void 0 : onChange(mergedChecked, event);
    }

    return mergedChecked;
  }

  function onInternalKeyDown(e) {
    if (e.which === KeyCode/* default.LEFT */.Z.LEFT) {
      triggerChange(false, e);
    } else if (e.which === KeyCode/* default.RIGHT */.Z.RIGHT) {
      triggerChange(true, e);
    }

    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
  }

  function onInternalClick(e) {
    var ret = triggerChange(!innerChecked, e); // [Legacy] trigger onClick with value

    onClick === null || onClick === void 0 ? void 0 : onClick(ret, e);
  }

  var switchClassName = classnames_default()(prefixCls, className, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-checked"), innerChecked), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
  return react.createElement("button", Object.assign({}, restProps, {
    type: "button",
    role: "switch",
    "aria-checked": innerChecked,
    disabled: disabled,
    className: switchClassName,
    ref: ref,
    onKeyDown: onInternalKeyDown,
    onClick: onInternalClick
  }), loadingIcon, react.createElement("span", {
    className: "".concat(prefixCls, "-inner")
  }, innerChecked ? checkedChildren : unCheckedChildren));
});
Switch.displayName = 'Switch';
/* harmony default export */ var es = (Switch);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LoadingOutlined.js + 1 modules
var LoadingOutlined = __webpack_require__(50888);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/wave.js + 1 modules
var wave = __webpack_require__(68349);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js + 1 modules
var context = __webpack_require__(59844);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/SizeContext.js
var SizeContext = __webpack_require__(97647);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/devWarning.js
var devWarning = __webpack_require__(21687);
;// CONCATENATED MODULE: ./node_modules/antd/es/switch/index.js



var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};









var switch_Switch = /*#__PURE__*/react.forwardRef(function (_a, ref) {
  var _classNames;

  var customizePrefixCls = _a.prefixCls,
      customizeSize = _a.size,
      loading = _a.loading,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      disabled = _a.disabled,
      props = __rest(_a, ["prefixCls", "size", "loading", "className", "disabled"]);

  (0,devWarning/* default */.Z)('checked' in props || !('value' in props), 'Switch', '`value` is not a valid prop, do you mean `checked`?');

  var _React$useContext = react.useContext(context/* ConfigContext */.E_),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var size = react.useContext(SizeContext/* default */.Z);
  var prefixCls = getPrefixCls('switch', customizePrefixCls);
  var loadingIcon = /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-handle")
  }, loading && /*#__PURE__*/react.createElement(LoadingOutlined/* default */.Z, {
    className: "".concat(prefixCls, "-loading-icon")
  }));
  var classes = classnames_default()((_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-small"), (customizeSize || size) === 'small'), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-loading"), loading), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
  return /*#__PURE__*/react.createElement(wave/* default */.Z, {
    insertExtraNode: true
  }, /*#__PURE__*/react.createElement(es, (0,esm_extends/* default */.Z)({}, props, {
    prefixCls: prefixCls,
    className: classes,
    disabled: disabled || loading,
    ref: ref,
    loadingIcon: loadingIcon
  })));
});
switch_Switch.__ANT_SWITCH = true;
switch_Switch.displayName = 'Switch';
/* harmony default export */ var es_switch = (switch_Switch);

/***/ }),

/***/ 60227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export ConfigNavigationItem */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border-right: 5px solid ",
        ";\n      background: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  padding: 0 8px;\n  border: 1px solid ",
        ";\n  border-bottom: 0 solid;\n  transition: background 0.3s;\n  background: ",
        ";\n  cursor: pointer;\n  position: relative;\n  height: ",
        ";\n\n  :hover {\n    transition: background 0.3s;\n    background: ",
        ";\n    border-right: 5px solid ",
        ";\n  }\n\n  :first-of-type {\n    border-radius: 2px 2px 0 0;\n  }\n\n  :last-of-type {\n    border-radius: 0 0 2px;\n    border-bottom: 1px solid ",
        ";\n  }\n\n  > * {\n    color: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ConfigNavigationItem = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].li.attrs */ .ZP.li.attrs(function(props) {
    return {
        isActive: props.isActive || false,
        height: props.height || "40px"
    };
}).withConfig({
    componentId: "sc-46da6bf5-0"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, function(param) {
    var height = param.height;
    return height;
}, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].aliceBlue */ .Z.aliceBlue, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].aliceBlue */ .Z.aliceBlue);
});
ConfigNavigationItem.propTypes = {
    isActive: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
ConfigNavigationItem.defaultProps = {
    isActive: false,
    height: "40px"
};
/* harmony default export */ __webpack_exports__["Z"] = (ConfigNavigationItem);


/***/ }),

/***/ 16484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vt": function() { return /* reexport */ profile_ConfigNavigation; },
  "SS": function() { return /* reexport */ ConfigNavigationItem/* default */.Z; },
  "Bo": function() { return /* reexport */ profile_ProfileCollapse; },
  "iU": function() { return /* reexport */ profile_ProfileNotificationCheckGroup; },
  "IH": function() { return /* reexport */ profile_ProfileSwitch; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/switch/index.js + 1 modules
var es_switch = __webpack_require__(94594);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/@deprecated-ui/profile/ProfileSwitch.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border: 1px solid ",
        ";\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n\n  :focus {\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n\n  .ant-switch-handle {\n    border-radius: 50%;\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ProfileSwitch = (0,styled_components_browser_esm/* default */.ZP)(es_switch/* default */.Z).withConfig({
    componentId: "sc-f9047c38-0"
})(_templateObject1(), color/* default.gainsboro */.Z.gainsboro, color/* default.light */.Z.light, function(param) {
    var checked = param.checked;
    return checked && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), color/* default.primary */.Z.primary);
});
/* harmony default export */ var profile_ProfileSwitch = (ProfileSwitch);

// EXTERNAL MODULE: ./node_modules/antd/es/collapse/index.js + 6 modules
var collapse = __webpack_require__(54907);
;// CONCATENATED MODULE: ./src/@deprecated-ui/profile/ProfileCollapse.js

function ProfileCollapse_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: white;\n  width: 100%;\n\n  .ant-collapse-header {\n    line-height: 40px;\n    font-size: 16px;\n    color: ",
        ";\n    font-weight: 600;\n    padding: 12px 0;\n  }\n\n  .ant-collapse-item {\n    :last-child {\n      border-bottom: none;\n    }\n  }\n"
    ]);
    ProfileCollapse_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ProfileCollapse = (0,styled_components_browser_esm/* default */.ZP)(collapse/* default */.Z).attrs(function() {
    return {
        defaultActiveKey: [
            "1"
        ],
        expandIconPosition: "right",
        bordered: false,
        accordion: true
    };
}).withConfig({
    componentId: "sc-1ae32541-0"
})(ProfileCollapse_templateObject(), color/* default.nightRider */.Z.nightRider);
/* harmony default export */ var profile_ProfileCollapse = (ProfileCollapse);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/index.js + 5 modules
var common = __webpack_require__(48308);
;// CONCATENATED MODULE: ./src/@deprecated-ui/profile/ProfileNotificationCheckGroup.js

function ProfileNotificationCheckGroup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border: none;\n\n  span {\n    font-size: 12px;\n    font-weight: normal;\n    color: ",
        ";\n\n    border-bottom: 1px solid ",
        ";\n\n    width: 100%;\n  }\n\n  > div {\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    ProfileNotificationCheckGroup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ProfileNotificationCheckGroup = (0,styled_components_browser_esm/* default */.ZP)(common/* Flex */.kC).attrs(function() {
    return {
        direction: "column",
        width: "100%"
    };
}).withConfig({
    componentId: "sc-966d0cb4-0"
})(ProfileNotificationCheckGroup_templateObject(), color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro, color/* default.primary */.Z.primary, color/* default.gainsboro */.Z.gainsboro, color/* default.gainsboro */.Z.gainsboro);
/* harmony default export */ var profile_ProfileNotificationCheckGroup = (ProfileNotificationCheckGroup);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/@deprecated-ui/profile/ConfigNavigation.js

function ConfigNavigation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  padding: 0;\n  margin: 30px 0 0;\n\n  width: ",
        ";\n"
    ]);
    ConfigNavigation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ConfigNavigation = styled_components_browser_esm/* default.ul.attrs */.ZP.ul.attrs(function(props) {
    return {
        width: props.width || "180px"
    };
}).withConfig({
    componentId: "sc-e44bb7f8-0"
})(ConfigNavigation_templateObject(), function(param) {
    var width = param.width;
    return width;
});
ConfigNavigation.propTypes = {
    width: (prop_types_default()).string
};
ConfigNavigation.defaultProps = {
    width: "180px"
};
/* harmony default export */ var profile_ConfigNavigation = (ConfigNavigation);

// EXTERNAL MODULE: ./src/@deprecated-ui/profile/ConfigNavigationItem.js
var ConfigNavigationItem = __webpack_require__(60227);
;// CONCATENATED MODULE: ./src/@deprecated-ui/profile/index.js







/***/ }),

/***/ 686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ LinkedDeviceBanner; },
/* harmony export */   "B5": function() { return /* binding */ NavigationHeader; },
/* harmony export */   "BP": function() { return /* binding */ LeftNavigation; },
/* harmony export */   "EU": function() { return /* binding */ RadioButton; },
/* harmony export */   "G_": function() { return /* binding */ PasswordSubmitButton; },
/* harmony export */   "Gd": function() { return /* binding */ LinkedDeviceCard; },
/* harmony export */   "IH": function() { return /* binding */ ProfileSwitch; },
/* harmony export */   "KX": function() { return /* binding */ LinkedDeviceButtonWrapper; },
/* harmony export */   "Ky": function() { return /* binding */ ProfileLabel; },
/* harmony export */   "Ol": function() { return /* binding */ CardHeader; },
/* harmony export */   "Tc": function() { return /* binding */ CustomConfigNavigation; },
/* harmony export */   "U1": function() { return /* binding */ ProfileInputGroup; },
/* harmony export */   "W2": function() { return /* binding */ LinkedDeviceModal; },
/* harmony export */   "WG": function() { return /* binding */ RegionFlag; },
/* harmony export */   "WX": function() { return /* binding */ CardHeaderTextContainer; },
/* harmony export */   "XZ": function() { return /* binding */ Checkbox; },
/* harmony export */   "aO": function() { return /* binding */ CardHeaderExtra; },
/* harmony export */   "aj": function() { return /* binding */ NotificationWrapper; },
/* harmony export */   "c": function() { return /* binding */ LinkedDeviceInformation; },
/* harmony export */   "eX": function() { return /* binding */ SectionLabel; },
/* harmony export */   "hS": function() { return /* binding */ EditProfileContainer; },
/* harmony export */   "ke": function() { return /* binding */ CheckboxLabel; },
/* harmony export */   "kr": function() { return /* binding */ CustomNavigationItem; },
/* harmony export */   "m$": function() { return /* binding */ PasswordCancelButton; },
/* harmony export */   "nh": function() { return /* binding */ DevicesTitle; },
/* harmony export */   "pr": function() { return /* binding */ EditProfileCard; },
/* harmony export */   "t$": function() { return /* binding */ LinkedDeviceButton; },
/* harmony export */   "u_": function() { return /* binding */ Modal; },
/* harmony export */   "vD": function() { return /* binding */ LinkedDeviceItem; },
/* harmony export */   "wP": function() { return /* binding */ CardHeaderTitle; },
/* harmony export */   "wy": function() { return /* binding */ PrivacySectionTitle; }
/* harmony export */ });
/* unused harmony exports IconMoreWrapper, Frame, Avatar, NavigationItem, TogglePassword, InputPassword */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_common_Card__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81301);
/* harmony import */ var _deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81190);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_profile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16484);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22147);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 30%;\n  margin-right: 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 180px;\n  border: solid 1px ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 180px;\n  height: 180px;\n  background: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  background: ",
        ";\n  padding: 15px 29px;\n  border: 1px solid ",
        ";\n  border-bottom: none;\n  border-radius: 3px 3px 0 0 !important;\n  width: 100%;\n\n  img {\n    display: block;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-left: 10px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: 'center';\n  align-items: 'flex-end';\n  width: 30px;\n  height: 40px;\n  display: flex;\n  transform: rotate(90deg);\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  border: 1px solid ",
        ";\n  border-bottom: 0 solid;\n  transition: background 0.3s;\n  background: ",
        ";\n  cursor: pointer;\n  position: relative;\n  height: ",
        ";\n\n  &:last-of-type {\n    border-radius: 0 0 3px 3px;\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: 16px;\n  min-width: 150px;\n  color: ",
        ";\n  text-align: start;\n\n  @media ",
        " {\n    text-align: end;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 100%;\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  margin-bottom: 24px;\n  ",
        "\n\n  .ant-input-group-wrapper {\n    border: none !important;\n  }\n\n  @media ",
        " {\n    align-items: flex-start;\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  :checked + label {\n    border-radius: 4px;\n    border: 2px solid ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 40px;\n  display: block;\n  position: relative;\n  cursor: pointer;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 8px 2px;\n  font-size: 12px;\n  font-weight: 400;\n  color: ",
        ";\n  width: calc(100% - 16px) !important;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  width: 100%;\n  padding: 10px 8px;\n  border: none !important;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        background: ",
        ";\n      "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  width: 100%;\n  padding: 24px 20px;\n  border-right: 1px solid ",
        ";\n  align-items: center;\n\n  :hover {\n    border-right: 1px solid ",
        ";\n  }\n\n  &:last-of-type {\n    border-radius: 0 0 3px 3px !important;\n  }\n\n  :before {\n    content: '';\n    position: absolute;\n    right: 0;\n    width: 3px;\n    height: 100%;\n    background: transparent;\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  padding: 20px;\n  border: 1px solid ",
        ";\n  border-bottom: 0 solid;\n  background: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0;\n  width: 100%;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-card-head {\n    border-color: ",
        ";\n  }\n\n  .ant-card-head-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    margin: 0 -5px;\n  }\n\n  .ant-card-head-title {\n    font-size: 16px;\n    color: ",
        ";\n    padding: 0;\n  }\n\n  .ant-card-extra {\n    font-size: 14px;\n    margin-left: 0px;\n    padding: 0px;\n  }\n\n  .ant-btn-primary[disabled] {\n    background: #8cd9bc !important;\n    color: #ffffff !important;\n  }\n\n  @media ",
        " {\n    .ant-card-head-wrapper {\n      display: flex;\n      flex-direction: row;\n      padding: 16px 5px;\n    }\n\n    .ant-card-head-title {\n      margin: 0;\n      padding: 0;\n    }\n\n    .ant-card-extra {\n      font-size: 16px;\n      margin: 0;\n      padding: 0;\n    }\n  }\n\n  @media ",
        " {\n    .ant-card-extra {\n      margin: 0;\n      padding: 0;\n    }\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-checkbox-inner {\n    border-radius: 100% !important;\n  }\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background: ",
        ";\n    border-color: ",
        "!important;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: -25px;\n  margin-top: 8px;\n  z-index: 99;\n  width: 15px;\n  cursor: pointer;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 95px;\n  height: 35px;\n  border-radius: 2px;\n  border: none;\n  font-family: var(--bold-font);\n  background: ",
        ";\n  color: ",
        ";\n  margin-left: 10px;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none !important;\n  min-width: 95px;\n  height: 35px;\n  font-family: var(--bold-font);\n  background: ",
        " !important;\n  color: ",
        " !important;\n  box-shadow: none;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid\n    ",
        " !important;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  width: calc(100% - 210px);\n\n  .ant-btn-primary[disabled] {\n    background: #8cd9bc !important;\n    color: #ffffff !important;\n\n    &:hover > p {\n      color: #ffffff;\n    }\n  }\n\n  button.ant-btn {\n    box-shadow: none;\n    margin-right: 10px;\n  }\n\n  & > div {\n    border-radius: 3px;\n  }\n\n  & > div:nth-child(2) {\n    border-radius: 0 0 3px 3px;\n  }\n\n  @media ",
        " {\n    width: 530px;\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          border: none;\n        "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    padding: 0 20px !important;\n    height: 40px;\n    border-bottom: solid 1px ",
        ";\n\n    ",
        "\n  }\n  .ant-modal-body {\n    padding: 20px;\n  }\n  .ant-modal-footer {\n    padding: 0 !important;\n    text-align: left;\n    display: flex;\n\n    button {\n      border-radius: 3px;\n    }\n  }\n  .ant-modal-close-x {\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  background: #f7f7f7;\n  margin: 20px 20px 16px 20px;\n\n  span {\n    margin-left: 10px;\n    font-size: 12px;\n    line-height: 16px;\n    color: #858585;\n    font-weight: 400;\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  border-bottom: 1px solid #f1f1f1;\n  padding: 14px 0;\n  margin: 0 20px;\n\n  p {\n    margin-bottom: 2px;\n  }\n\n  .device-name {\n    font-size: 14px;\n    line-height: 18px;\n\n    span {\n      color: #00ab6b;\n    }\n\n    span::before {\n      content: ' • ';\n      color: #333333;\n    }\n  }\n\n  .device-login-information {\n    font-size: 12px;\n    line-height: 16px;\n    color: #858585;\n  }\n\n  .device-remove {\n    cursor: pointer;\n    font-size: 10px;\n    margin-left: auto;\n    padding-top: 22px;\n  }\n\n  .device-icon {\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  color: #00ab6b;\n  font-size: 14px;\n  line-height: 18px;\n  padding: 16px 20px 20px;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    border-radius: 8px;\n  }\n\n  .ant-modal-header {\n    border-radius: 8px 8px 0 0;\n    border-bottom: none;\n    padding: 20px 20px 12px 20px !important;\n  }\n\n  .ant-modal-title {\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 17px;\n  }\n\n  .ant-modal-body {\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  padding: 10px 20px 20px;\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          border: 1px solid #00ab6b;\n          color: #ffffff;\n          background: #00ab6b;\n        "
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          border: 1px solid #ededed;\n          color: #333333;\n          background: #ffffff;\n        "
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  min-width: 120px;\n  min-height: 40px;\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: 700;\n  align: center;\n  border-radius: 4px;\n  margin: 0 10px;\n\n  ",
        "\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 35px;\n  background-color: #f7f7f7;\n  color: #858585;\n\n  p {\n    height: 35px;\n    line-height: 35px;\n    padding-left: 20px;\n  }\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-card-body {\n    padding: 0px;\n  }\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}












var LeftNavigation = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4cb90a24-0"
})(_templateObject());
var Frame = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    direction: "column",
    align: "center"
}).withConfig({
    componentId: "sc-4cb90a24-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro);
var Avatar = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4cb90a24-2"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].mischka */ .Z.mischka);
var CardHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4cb90a24-3"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro);
var CardHeaderTextContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4cb90a24-4"
})(_templateObject4());
var CardHeaderTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    size: "16px"
}).withConfig({
    componentId: "sc-4cb90a24-5"
})(_templateObject5());
var CardHeaderExtra = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    size: "14px",
    align: "right",
    color: "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary)
}).withConfig({
    componentId: "sc-4cb90a24-6"
})(_templateObject6());
var IconMoreWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4cb90a24-7"
})(_templateObject7(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_9__/* ["default"].tablet */ .Z.tablet);
var NavigationItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs(function(props) {
    return {
        isActive: props.isActive || false,
        height: props.height || "40px"
    };
}).withConfig({
    componentId: "sc-4cb90a24-8"
})(_templateObject8(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].light */ .Z.light, function(param) {
    var height = param.height;
    return height;
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro);
var ProfileLabel = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].label.attrs */ .ZP.label.attrs({
    className: "control-label"
}).withConfig({
    componentId: "sc-4cb90a24-9"
})(_templateObject9(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].highempahis */ .Z.highempahis, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_9__/* ["default"].tablet */ .Z.tablet);
var ProfileInputGroup = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs(function(props) {
    return {
        // @ts-expect-error
        isFluid: props.isFluid || false,
        // @ts-expect-error
        align: props.align || "center",
        className: "control-group"
    };
}).withConfig({
    componentId: "sc-4cb90a24-10"
})(_templateObject11(), function(param) {
    var isFluid = param.isFluid;
    return isFluid && (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject10());
}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_9__/* ["default"].tablet */ .Z.tablet);
var RadioButton = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-4cb90a24-11"
})(_templateObject12(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary);
var RegionFlag = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4cb90a24-12"
})(_templateObject13());
var CheckboxLabel = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-4cb90a24-13"
})(_templateObject14(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].highempahis */ .Z.highempahis);
var SectionLabel = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-4cb90a24-14"
})(_templateObject15(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary);
var NotificationWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4cb90a24-15"
})(_templateObject16());
var ProfileSwitch = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_profile__WEBPACK_IMPORTED_MODULE_8__/* .ProfileSwitch */ .IH).withConfig({
    componentId: "sc-4cb90a24-16"
})(_templateObject18(), function(param) {
    var checked = param.checked;
    return checked && (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject17(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary);
});
var CustomNavigationItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_profile__WEBPACK_IMPORTED_MODULE_8__/* .ConfigNavigationItem */ .SS).withConfig({
    componentId: "sc-4cb90a24-17"
})(_templateObject21(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject19(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary);
}, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject20(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].aliceBlue */ .Z.aliceBlue);
});
var NavigationHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4cb90a24-18"
})(_templateObject22(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].light */ .Z.light);
var CustomConfigNavigation = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_profile__WEBPACK_IMPORTED_MODULE_8__/* .ConfigNavigation */ .Vt).withConfig({
    componentId: "sc-4cb90a24-19"
})(_templateObject23());
var EditProfileCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Card__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4cb90a24-20"
})(_templateObject24(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro, function(props) {
    return(// @ts-expect-error
    props.isHideTitle ? "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].light */ .Z.light) : "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary));
}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_9__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_9__/* ["default"].laptop */ .Z.laptop);
var PrivacySectionTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    width: "100%",
    pb: "20px"
}).withConfig({
    componentId: "sc-4cb90a24-21"
})(_templateObject25(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].downgray */ .Z.downgray);
var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4cb90a24-22"
})(_templateObject26(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary);
var TogglePassword = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4cb90a24-23"
})(_templateObject27());
var PasswordSubmitButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4cb90a24-24"
})(_templateObject28(), function(props) {
    return props.disabled ? "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary, " !important") : "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].primary */ .Z.primary);
}, function(props) {
    return props.disabled ? "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].light */ .Z.light, " !important") : "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].light */ .Z.light);
});
var PasswordCancelButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4cb90a24-25"
})(_templateObject29(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].midgray */ .Z.midgray);
var InputPassword = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).attrs({
    autoComplete: "new-password"
}).withConfig({
    componentId: "sc-4cb90a24-26"
})(_templateObject30(), function(props) {
    return(// @ts-expect-error
    props.error ? "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].sunsetOrange */ .Z.sunsetOrange) : "".concat(_deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro));
});
var EditProfileContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4cb90a24-27"
})(_templateObject31(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_9__/* ["default"].laptop */ .Z.laptop);
var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4cb90a24-28"
})(_templateObject33(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_10__/* ["default"].gainsboro */ .Z.gainsboro, // @ts-expect-error
function(param) {
    var noBorder = param.noBorder;
    return noBorder && (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject32());
});
var LinkedDeviceBanner = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4cb90a24-29"
})(_templateObject34());
var LinkedDeviceItem = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4cb90a24-30"
})(_templateObject35());
var LinkedDeviceInformation = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4cb90a24-31"
})(_templateObject36());
var LinkedDeviceModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(Modal).withConfig({
    componentId: "sc-4cb90a24-32"
})(_templateObject37());
var LinkedDeviceButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4cb90a24-33"
})(_templateObject38());
var LinkedDeviceButton = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-4cb90a24-34"
})(_templateObject41(), function(props) {
    return props.primary ? (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject39()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject40());
});
var DevicesTitle = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4cb90a24-35"
})(_templateObject42());
var LinkedDeviceCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(EditProfileCard).withConfig({
    componentId: "sc-4cb90a24-36"
})(_templateObject43());



/***/ }),

/***/ 61785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_ModalShareTradeManager; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/features/sharetrade/stores/useShareTradeModal.ts
var useShareTradeModal = __webpack_require__(77064);
// EXTERNAL MODULE: ./src/features/sharetrade/analytics/shareTradeShareTracker.ts
var shareTradeShareTracker = __webpack_require__(56371);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/stores/sharetrade/useShareTradeShare.ts
var useShareTradeShare = __webpack_require__(75774);
// EXTERNAL MODULE: ./src/stores/sharetrade/useShareTradeTarget.ts
var useShareTradeTarget = __webpack_require__(972);
// EXTERNAL MODULE: ./src/features/sharetrade/utils/shareTradeOrder.ts + 1 modules
var shareTradeOrder = __webpack_require__(1473);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 14 modules
var es_form = __webpack_require__(98294);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/global/Securities/components/Checkbox/index.tsx
var Checkbox = __webpack_require__(19254);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalShareTrade/EmptyState/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100px;\n  height: auto;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18px;\n  color: #333333;\n  text-align: center;\n\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e0433b0-0"
})(_templateObject(), function(param) {
    var _height = param.height, height = _height === void 0 ? "auto" : _height;
    return height;
});
var ErrorIcon = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-e0433b0-1"
})(_templateObject1());
var InfoText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-e0433b0-2"
})(_templateObject2(), function(param) {
    var _color = param.color, color = _color === void 0 ? "#333333" : _color;
    return color;
});

;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalShareTrade/EmptyState/index.tsx


var EmptyState = function(param) {
    var height = param.height, textColor = param.textColor, _src = param.src, src = _src === void 0 ? "icon/empty-state-outline.svg" : _src, infoText = param.infoText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        height: height,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorIcon, {
                src: src
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, {
                color: textColor,
                children: infoText
            })
        ]
    });
};
/* harmony default export */ var ModalShareTrade_EmptyState = (EmptyState);

// EXTERNAL MODULE: ./src/features/sharetrade/components/ModalShareTrade/styled.ts
var styled = __webpack_require__(15350);
;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalShareTrade/index.tsx





















var ModalShareTrade = function(_param) {
    var _title = _param.title, title = _title === void 0 ? "Share Trade" : _title, _width = _param.width, width = _width === void 0 ? 430 : _width, modalVisible = _param.modalVisible, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "width",
        "modalVisible",
        "onSubmit"
    ]);
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useUIConfigStore/* default */.Z)(function(s) {
        var ref;
        return [
            (ref = s.getUIValue("shareTrade")) === null || ref === void 0 ? void 0 : ref.isTransactionBannerShown,
            s.setUIValue
        ];
    }, shallow/* default */.Z), 2), isTransactionBannerShown = ref2[0], setUIValue = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeModal/* default */.Z)(function(s) {
        return [
            s.selectedUsers,
            s.sharedUsers,
            s.setSelectedUsers
        ];
    }, shallow/* default */.Z), 3), selectedUsers = ref3[0], sharedUsers = ref3[1], setSelectedUsers = ref3[2];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeTarget/* default */.Z)(function(s) {
        return [
            s.data,
            s.error,
            s.isLoading,
            s.isEmptyList,
            s.loadShareTradeTarget,
            s.resetShareTradeTarget, 
        ];
    }, shallow/* default */.Z), 6), targetData = ref4[0], targetError = ref4[1], isTargetLoading = ref4[2], isEmptyList = ref4[3], loadShareTradeTarget = ref4[4], resetShareTradeTarget = ref4[5];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeShare/* default */.Z)(function(s) {
        return [
            s.transactionData,
            s.isLoading
        ];
    }, shallow/* default */.Z), 2), transactionData = ref5[0], isShareLoading = ref5[1];
    var isEmptySearch = (0,react.useMemo)(function() {
        var ref;
        return (targetData === null || targetData === void 0 ? void 0 : (ref = targetData.targets) === null || ref === void 0 ? void 0 : ref.length) === 0 && !!form.getFieldValue("userSearch");
    }, [
        (targetData === null || targetData === void 0 ? void 0 : (ref = targetData.targets) === null || ref === void 0 ? void 0 : ref.length) === 0,
        !!form.getFieldValue("userSearch")
    ]);
    var isShowAutoShare = (0,react.useMemo)(function() {
        return !targetError && !isEmptyList;
    }, [
        targetError,
        isEmptyList
    ]);
    var isShowUserList = (0,react.useMemo)(function() {
        return isShowAutoShare && !isEmptySearch;
    }, [
        isShowAutoShare,
        isEmptySearch
    ]);
    var isDisableSubmit = (0,react.useMemo)(function() {
        return Object.values(selectedUsers).length === 0 || isShareLoading;
    }, [
        Object.values(selectedUsers).length,
        isShareLoading
    ]);
    var userListData = (0,react.useMemo)(function() {
        // Map over sharedUsers and tag them as shared
        var taggedSharedUsers = Object.values(sharedUsers).map(function(user) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
                is_shared: true
            });
        });
        // Filter targetData to exclude shared users and map over remaining ones
        var filteredTargetData = ((targetData === null || targetData === void 0 ? void 0 : targetData.targets) || []).filter(function(user) {
            return !sharedUsers[user.id];
        }).map(function(user) {
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
                is_share_value: ((ref = selectedUsers[user.id]) === null || ref === void 0 ? void 0 : ref.is_share_value) || user.is_share_value
            });
        });
        // Combine both arrays
        return (0,_to_consumable_array/* default */.Z)(taggedSharedUsers).concat((0,_to_consumable_array/* default */.Z)(filteredTargetData));
    }, [
        targetData === null || targetData === void 0 ? void 0 : targetData.targets,
        selectedUsers,
        sharedUsers,
        isTargetLoading
    ]);
    var previewShareTrade = (0,react.useMemo)(function() {
        return (0,shareTradeOrder/* getPreviewData */.oD)(transactionData);
    }, [
        transactionData
    ]);
    var handleBannerClose = function() {
        setUIValue("shareTrade", function(state) {
            state.isTransactionBannerShown = true;
        });
    };
    var handleResetSelectedUsers = (0,react.useCallback)(function() {
        setSelectedUsers({});
    }, [
        setSelectedUsers
    ]);
    var handleSelectedUserChange = function(isSelected, userTarget) {
        setSelectedUsers((0,immer_esm/* default */.ZP)(selectedUsers, function(state) {
            if (!isSelected && state[userTarget.id]) {
                delete state[userTarget.id];
                return;
            }
            state[userTarget.id] = userTarget;
        }));
    };
    var handleLoadUserNextPage = function() {
        var ref;
        if (targetData === null || targetData === void 0 ? void 0 : (ref = targetData.pagination) === null || ref === void 0 ? void 0 : ref.next_cursor) {
            loadShareTradeTarget({
                cursor: targetData.pagination.next_cursor,
                keyword: form.getFieldValue("userSearch")
            });
        }
    };
    var handleSearchChange = lodash_debounce_default()(function() {
        loadShareTradeTarget({
            keyword: form.getFieldValue("userSearch")
        }, true);
    }, 300);
    var handleShareClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        onSubmit(form.getFieldValue("saveAsAutoShare"));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleShareClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleInitialLoad = (0,react.useCallback)(function() {
        loadShareTradeTarget({
            initialLoad: true
        });
    }, [
        loadShareTradeTarget
    ]);
    var handleResetShareTrade = (0,react.useCallback)(function() {
        handleResetSelectedUsers();
        resetShareTradeTarget();
        form.resetFields();
    }, [
        handleResetSelectedUsers,
        resetShareTradeTarget
    ]);
    (0,react.useEffect)(function() {
        if (modalVisible) {
            handleInitialLoad();
        } else {
            handleResetShareTrade();
        }
    }, [
        modalVisible,
        handleResetShareTrade
    ]);
    (0,react.useEffect)(function() {
        document.body.classList.add("disabled-popover-animation");
        return function() {
            document.body.classList.remove("disabled-popover-animation");
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        width: width
    }, props), {
        children: [
            targetError && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ErrorState */.Te, {
                iconSrc: "/icon/error-document-retry.svg",
                description: "Unable to Load Data",
                onRetry: handleInitialLoad,
                loading: isTargetLoading
            }),
            isEmptyList && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTrade_EmptyState, {
                textColor: "#969696",
                height: "276px",
                src: "icon/empty-state-outline.svg",
                infoText: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "You can only share trades with your groups",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " or friends in your chat list"
                    ]
                })
            }),
            isShowAutoShare && /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
                form: form,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* HeaderRow */.VJ, {
                        children: [
                            !isTransactionBannerShown && /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Alert */.bZ, {
                                    message: "You can manage your Auto-Share list from Settings",
                                    afterClose: handleBannerClose
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                name: "userSearch",
                                noStyle: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* SearchInput */.Mj, {
                                    name: "userSearch",
                                    placeholder: "Search chat list",
                                    onChange: handleSearchChange
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ListTitle */.AO, {
                                    children: "Send to"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                            span: 24,
                            children: [
                                isEmptySearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTrade_EmptyState, {
                                    height: "356px",
                                    src: "icon/empty-state-outline.svg",
                                    infoText: "No result found. Chat with your friends first."
                                }),
                                isShowUserList && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* UserList */.Z7, {
                                    data: userListData,
                                    defaultCheckedKey: "is_shared",
                                    defaultSwitchKey: "is_share_value",
                                    disableSharedKey: [
                                        "is_autoshare_active",
                                        "is_shared"
                                    ],
                                    previewShareTrade: previewShareTrade,
                                    onSelectedUserChange: handleSelectedUserChange,
                                    onScrollToBottom: handleLoadUserNextPage,
                                    disableSharedUsers: true,
                                    isLoading: isTargetLoading
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* FooterCol */.zg, {
                        span: 24,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                            align: "middle",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                    span: 24,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* AgreementRow */.GY, {
                                        align: "middle",
                                        justify: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* AgreementText */.NL, {
                                                        children: "Add newly selected to next Auto Share’s"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* AgreementDescription */.mE, {
                                                        children: "Share Investment Amount settings can be changed via Privacy"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                                name: "saveAsAutoShare",
                                                initialValue: false,
                                                valuePropName: "checked",
                                                noStyle: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {})
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                    span: 24,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* SubmitButton */.Mm, {
                                        type: "primary",
                                        onClick: handleShareClick,
                                        loading: isShareLoading,
                                        disabled: isDisableSubmit,
                                        block: true,
                                        children: "Share"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_ModalShareTrade = (ModalShareTrade);

// EXTERNAL MODULE: ./src/features/sharetrade/components/ModalShareConfirm/index.tsx + 2 modules
var ModalShareConfirm = __webpack_require__(20242);
// EXTERNAL MODULE: ./src/global/Modal/BaseModal/index.tsx
var BaseModal = __webpack_require__(16981);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./src/global/Modal/BaseConfirmationModal/index.tsx
var BaseConfirmationModal = __webpack_require__(51595);
;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalSuccessInfo/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-modal-body {\n    padding: 18px 0 8px;\n  }\n\n  & .base-modal-header {\n    margin-bottom: 18px;\n  }\n\n  & .button-row {\n    padding: 20px;\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 160px;\n  height: auto;\n\n  margin-bottom: 24px;\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 20px 0;\n  gap: 12px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 44px;\n  color: #ffffff;\n  border-radius: 4px;\n\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n\n  padding: 12px 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 44px;\n  color: #00ab6b;\n  border-radius: 4px;\n  border: none;\n  box-shadow: none;\n\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n\n  padding: 12px 20px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var Modal = (0,styled_components_browser_esm/* default */.ZP)(BaseConfirmationModal/* default */.Z).withConfig({
    componentId: "sc-bfb12a79-0"
})(styled_templateObject());
var InfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bfb12a79-1"
})(styled_templateObject1());
var Illustration = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-bfb12a79-2"
})(styled_templateObject2());
var styled_InfoText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-bfb12a79-3"
})(_templateObject3());
var ButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bfb12a79-4"
})(_templateObject4());
var ConfirmButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-bfb12a79-5"
})(_templateObject5());
var LinkButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-bfb12a79-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalSuccessInfo/index.tsx






var ModalSuccessInfo = function(_param) /*#__PURE__*/ {
    var _src = _param.src, src = _src === void 0 ? "/img/share-trade-delivered.svg" : _src, _infoText = _param.infoText, infoText = _infoText === void 0 ? "Order has been shared" : _infoText, props = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "infoText"
    ]);
    return (0,jsx_runtime.jsxs)(BaseModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 430
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration, {
                        src: src
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_InfoText, {
                        children: infoText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmButton, {
                        type: "primary",
                        onClick: props.onSuccess,
                        loading: props.confirmLoading,
                        block: true,
                        children: "Done"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton, {
                        onClick: props.onBack,
                        block: true,
                        children: "Go to Chat List"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_ModalSuccessInfo = (ModalSuccessInfo);

;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalShareTradeManager/index.tsx




















var ShowModal;
(function(ShowModal) {
    ShowModal["SELECT"] = "SELECT";
    ShowModal["CONFIRM"] = "CONFIRM";
    ShowModal["SUCCESS"] = "SUCCESS";
})(ShowModal || (ShowModal = {}));
var ModalShareTradeManager = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), isAutoShareOn = ref[0], setIsAutoShareOn = ref[1];
    var ref1 = (0,react.useState)(null), showModal = ref1[0], setShowModal = ref1[1];
    var symbol = (0,store/* default */.Z)(function(s) {
        return s.symbol;
    });
    var resetModal = (0,store/* default */.Z)(function(s) {
        return s.resetModal;
    });
    var usersData = (0,useShareTradeTarget/* default */.Z)(function(s) {
        return s.data;
    });
    var resetModalData = (0,tradingData/* default */.Z)(function(s) {
        return s.resetModalData;
    });
    var resetCompany = (0,tradingData/* default */.Z)(function(s) {
        return s.resetCompany;
    });
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeModal/* default */.Z)(function(s) {
        return [
            s.isVisible,
            s.setIsVisible
        ];
    }, shallow/* default */.Z), 2), isVisible = ref2[0], setIsVisible = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeModal/* default */.Z)(function(s) {
        return [
            s.selectedUsers,
            s.sharedUsers,
            s.setSelectedUsers,
            s.setSharedUsers, 
        ];
    }, shallow/* default */.Z), 4), selectedUsers = ref3[0], sharedUsers = ref3[1], setSelectedUsers = ref3[2], setSharedUsers = ref3[3];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeShare/* default */.Z)(function(s) {
        return [
            s.transactionData,
            s.isLoading,
            s.loadShareTradeShare,
            s.setTransactionData, 
        ];
    }, shallow/* default */.Z), 4), transactionData = ref4[0], isShareLoading = ref4[1], loadShareTradeShare = ref4[2], setTransactionData = ref4[3];
    var previewShareTrade = (0,react.useMemo)(function() {
        return (0,shareTradeOrder/* getPreviewData */.oD)(transactionData);
    }, [
        transactionData
    ]);
    var userSelectedList = (0,react.useMemo)(function() {
        if (!(usersData === null || usersData === void 0 ? void 0 : usersData.targets)) return [];
        return usersData.targets.filter(function(user) {
            return selectedUsers[user.id];
        }).map(function(user) {
            return (0,_object_spread/* default */.Z)({}, user, selectedUsers[user.id]);
        });
    }, [
        usersData === null || usersData === void 0 ? void 0 : usersData.targets,
        selectedUsers
    ]);
    var handleCloseModalShare = function() {
        setIsVisible(false);
        setShowModal(null);
        setSelectedUsers({});
    };
    var handleSubmitSelect = function(isAddAutoShare) {
        setIsAutoShareOn(isAddAutoShare);
        setShowModal(ShowModal.CONFIRM);
    };
    var handleCancelConfirm = function() {
        setShowModal(ShowModal.SELECT);
    };
    var handleShareConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var postData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, transactionData), {
                            targets: Object.values(selectedUsers).map(function(param) {
                                var id = param.id, type = param.type, is_share_value = param.is_share_value;
                                return {
                                    id: id,
                                    type: type,
                                    is_share_value: is_share_value
                                };
                            }),
                            save_as_autoshare: isAutoShareOn
                        });
                        delete postData.total_investment;
                        _ctx.next = 4;
                        return loadShareTradeShare(postData);
                    case 4:
                        setSharedUsers((0,_object_spread/* default */.Z)({}, sharedUsers, selectedUsers));
                        setSelectedUsers({});
                        setShowModal(ShowModal.SUCCESS);
                        (0,shareTradeShareTracker/* trackShareSelected */.J4)(symbol, isAutoShareOn);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleShareConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSwitchChange = function(checked, user) {
        setSelectedUsers((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedUsers), (0,_define_property/* default */.Z)({}, user.id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
            is_share_value: checked
        }))));
    };
    var handleShareSuccess = function() {
        handleCloseModalShare();
        (0,shareTradeShareTracker/* trackDoneSelected */.tE)(symbol);
    };
    var handleBackToChatList = function() {
        // Reset all modal states
        resetCompany();
        resetModal();
        resetModalData();
        // Reset modal share
        setTransactionData(undefined);
        handleCloseModalShare();
        setSelectedUsers({});
        setSharedUsers({});
        // Redirect to chat
        router.push("/chat");
    };
    (0,react.useEffect)(function() {
        if (isVisible) setShowModal(ShowModal.SELECT);
    }, [
        isVisible
    ]);
    (0,react.useEffect)(function() {
        if (showModal === ShowModal.SELECT) (0,shareTradeShareTracker/* trackOrderViewed */.g3)();
        if (showModal === ShowModal.SUCCESS) (0,shareTradeShareTracker/* trackTradeSharedViewed */.cP)();
    }, [
        showModal
    ]);
    (0,react.useEffect)(function() {
        if (isVisible) {
            document.body.classList.add("no-scroll");
        } else {
            document.body.classList.remove("no-scroll");
        }
        return function() {
            document.body.classList.remove("no-scroll");
        };
    }, [
        isVisible
    ]);
    if (!isVisible) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModalShareTrade, {
                visible: showModal === ShowModal.SELECT,
                modalVisible: isVisible,
                onCancel: handleCloseModalShare,
                onSubmit: handleSubmitSelect,
                zIndex: 1003
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareConfirm/* default */.Z, {
                visible: showModal === ShowModal.CONFIRM,
                selectedUsers: userSelectedList,
                previewShareTrade: previewShareTrade,
                isLoading: isShareLoading,
                onCancel: handleCancelConfirm,
                onConfirm: handleShareConfirm,
                onSwitchChange: handleSwitchChange,
                zIndex: 1004
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModalSuccessInfo, {
                visible: showModal === ShowModal.SUCCESS,
                onCancel: handleShareSuccess,
                onSuccess: handleShareSuccess,
                onBack: handleBackToChatList
            })
        ]
    });
};
/* harmony default export */ var components_ModalShareTradeManager = (ModalShareTradeManager);


/***/ })

}]);